import { useCallback } from 'react';
import axios, { CancelTokenSource } from 'axios';
import { useDispatch } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Dispatch } from 'redux';
import { triggerConvoFetching, triggerThreadsFetching } from '../../../actions/mailActions';
import { localMessageConversations } from '../../../utils/storedLocalData';

interface IUseMailFetchActions {
  fetchThreads: (page?: number) => void;
  fetchConversation: (page?: number) => void;
  getThreadsCancelTokenSource: CancelTokenSource;
}

const useMailFetchActions = (): IUseMailFetchActions => {
  const dispatch = useDispatch<Dispatch<any>>();
  const getThreadsCancelTokenSource: CancelTokenSource = axios.CancelToken.source();

  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const getConversationMessage = useCallback(() => {
    const params = window.location.pathname.split('/');
    const currentHashId = params[params.length - 1];

    const conversationMessage = localMessageConversations(currentHashId);

    return _isEmpty(conversationMessage) ? {} : conversationMessage;
  }, [location.pathname]);

  const fetchConversation = useCallback(
    (page = 1) => {
      const currentConversation = getConversationMessage();

      dispatch(triggerConvoFetching(currentConversation, params, navigate, location, page));
    },
    [getConversationMessage]
  );

  const fetchThreads = (page = 1) => {
    dispatch(triggerThreadsFetching(page, navigate, location, getThreadsCancelTokenSource));
  };

  return {
    fetchConversation,
    fetchThreads,
    getThreadsCancelTokenSource,
  };
};

export default useMailFetchActions;
